export default __webpack_public_path__ + "static/media/259.c3097959.jpg";